// Display active filters from URL query parameters (for tags filter system)
(function() {
  function displayActiveFilters() {
    const activeFacetsContainer = document.getElementById('ActiveFacets');
    if (!activeFacetsContainer) {
      return;
    }
    
    const currentUrl = new URL(window.location.href);
    const searchParams = currentUrl.searchParams;
    
    // Check if there are any active filters
    let hasActiveFilters = false;
    const priceGte = searchParams.get('filter.v.price.gte');
    const priceLte = searchParams.get('filter.v.price.lte');
    
    // Collect all filter.v.option.* parameters
    const optionFilters = {};
    for (const [key, value] of searchParams.entries()) {
      if (key.startsWith('filter.v.option.')) {
        if (!optionFilters[key]) {
          optionFilters[key] = [];
        }
        optionFilters[key].push(value);
        hasActiveFilters = true;
      }
    }
    
    if (priceGte || priceLte) {
      hasActiveFilters = true;
    }
    
    // Clear container
    activeFacetsContainer.innerHTML = '';
    
    if (!hasActiveFilters) {
      return;
    }
    
    // Helper function to build remove URL
    function buildRemoveUrl(excludeParam, excludeValue) {
      const removeUrl = new URL(window.location.href);
      const newParams = new URLSearchParams();
      
      // Copy all params except the excluded one
      for (const [key, value] of searchParams.entries()) {
        if (key === excludeParam && value === excludeValue) {
          continue; // Skip this specific value
        }
        if (key !== excludeParam) {
          newParams.append(key, value);
        } else {
          // Same param but different value - keep it
          newParams.append(key, value);
        }
      }
      
      // For option filters, we need to handle multiple values correctly
      if (excludeParam && excludeValue) {
        const values = searchParams.getAll(excludeParam);
        values.forEach(val => {
          if (val !== excludeValue) {
            newParams.append(excludeParam, val);
          }
        });
        // Remove the param first, then add back the values we want to keep
        newParams.delete(excludeParam);
        values.forEach(val => {
          if (val !== excludeValue) {
            newParams.append(excludeParam, val);
          }
        });
      }
      
      return removeUrl.pathname + (newParams.toString() ? '?' + newParams.toString() : '');
    }
    
    // Build remove URL for price filter (removes both gte and lte)
    function buildPriceRemoveUrl() {
      const removeUrl = new URL(window.location.href);
      const newParams = new URLSearchParams();
      
      for (const [key, value] of searchParams.entries()) {
        if (key !== 'filter.v.price.gte' && key !== 'filter.v.price.lte') {
          newParams.append(key, value);
        }
      }
      
      return removeUrl.pathname + (newParams.toString() ? '?' + newParams.toString() : '');
    }
    
    // Display price filter
    if (priceGte || priceLte) {
      const priceRemoveUrl = buildPriceRemoveUrl();
      
      // Format price display (values are already in dollars)
      const priceMinDisplay = priceGte ? parseFloat(priceGte).toFixed(2) : '0.00';
      const priceMaxDisplay = priceLte ? parseFloat(priceLte).toFixed(2) : '9999.00';
      
      const facetRemove = document.createElement('facet-remove');
      facetRemove.className = 'm-active-facets--item';
      facetRemove.setAttribute('data-filter-type', 'price');
      
      const link = document.createElement('a');
      link.href = priceRemoveUrl;
      link.className = 'm:flex';
      
      const icon = document.createElement('span');
      icon.className = 'm-active-facets--remove-icon';
      icon.innerHTML = `
        <svg class="m-svg-icon" fill="currentColor" stroke="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
          <path d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"/>
        </svg>
      `;
      
      const textSpan = document.createElement('span');
      textSpan.innerHTML = `$${priceMinDisplay}<span>-</span>$${priceMaxDisplay}`;
      
      link.appendChild(icon);
      link.appendChild(textSpan);
      facetRemove.appendChild(link);
      activeFacetsContainer.appendChild(facetRemove);
    }
    
    // Display option filters (color, size, etc.)
    for (const [filterName, values] of Object.entries(optionFilters)) {
      values.forEach((filterValue) => {
        const removeUrl = new URL(window.location.href);
        const newParams = new URLSearchParams();
        
        // Copy all params except the one we're removing
        for (const [key, value] of searchParams.entries()) {
          // Skip this specific filter value
          if (key === filterName && value === filterValue) {
            continue;
          }
          // For other params, add them
          if (key !== filterName) {
            newParams.append(key, value);
          }
        }
        
        // Re-add other values of the same filter type (excluding the one we're removing)
        const allValues = searchParams.getAll(filterName);
        allValues.forEach((val) => {
          if (val !== filterValue) {
            newParams.append(filterName, val);
          }
        });
        
        const removeUrlStr = removeUrl.pathname + (newParams.toString() ? '?' + newParams.toString() : '');
        
        const facetRemove = document.createElement('facet-remove');
        facetRemove.className = 'm-active-facets--item';
        facetRemove.setAttribute('data-filter-type', filterName.replace('filter.v.option.', ''));
        
        const link = document.createElement('a');
        link.href = removeUrlStr;
        
        const span = document.createElement('span');
        span.className = 'm:flex m:items-center';
        
        const icon = document.createElement('span');
        icon.className = 'm-active-facets--remove-icon';
        icon.innerHTML = `
          <svg class="m-svg-icon" fill="currentColor" stroke="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
            <path d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"/>
          </svg>
        `;
        
        const text = document.createTextNode(filterValue);
        
        span.appendChild(icon);
        span.appendChild(text);
        link.appendChild(span);
        facetRemove.appendChild(link);
        activeFacetsContainer.appendChild(facetRemove);
      });
    }
    
    // Add Clear all button
    const collectionUrl = activeFacetsContainer.getAttribute('data-collection-url') || window.location.pathname.split('?')[0];
    const sortBy = searchParams.get('sort_by');
    const clearAllUrl = collectionUrl + (sortBy ? '?sort_by=' + sortBy : '');
    
    const facetRemoveAll = document.createElement('facet-remove');
    facetRemoveAll.className = 'm-active-facets--item m-active-facets--item-remove-all';
    
    const clearAllLink = document.createElement('a');
    clearAllLink.href = clearAllUrl;
    clearAllLink.className = 'm-active-facets--remove-all';
    
    const clearAllText = document.createElement('span');
    clearAllText.textContent = 'Clear all';
    
    clearAllLink.appendChild(clearAllText);
    facetRemoveAll.appendChild(clearAllLink);
    activeFacetsContainer.appendChild(facetRemoveAll);
  }
  
  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', displayActiveFilters);
  } else {
    displayActiveFilters();
  }
  
  // Re-run on AJAX updates
  document.addEventListener('collection:rerendered', () => {
    setTimeout(displayActiveFilters, 100);
  });
})();
